module.exports = __webpack_public_path__ + "img/clothes-hanger.33e67d9e.svg";